import Vue from "vue";
import Vuelidate from "vuelidate";
import App from "./AppMain.vue";
import Meta from "vue-meta";
import { createStore } from "./store";
import { createRouter } from "./router";
import "./registerServiceWorker";
import Axios from "axios";

Vue.config.productionTip = false;

import VueMaterial from "vue-material"; //Complete VueMaterial Package
import "vue-material/dist/vue-material.min.css";
import "../src/dslv-style.scss"; //VueMaterial DSLV Theme
Vue.use(VueMaterial); //Complete VueMaterial Package

Vue.use(Vuelidate);
Vue.use(Meta);

import i18n from "./i18n";

const store = createStore();

Vue.mixin({
  methods: {
    trail: (data) => {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const height =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;

      Axios.post("/trail", {
        ...data,
        deviceId: store.state.deviceId,
        device: {
          id: store.state.deviceId,
          screenSize: width + "x" + height,
        },
        createdAt: new Date(),
      });
    },
  },
});

new Vue({
  router: createRouter({
    questionnaires: Object.values(store.state.questionnaires),
  }),
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
